import React from 'react';


const IconSignalLow: React.FC = () => (
    <svg className="iconSignalLow" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
            d="M15.166 1H17.166V17H15.166V1ZM14.166 0H15.166H17.166H18.166V1V17V18H17.166H15.166H14.166V17V1V0ZM10.166 7H8.16602V17H10.166V7ZM8.16602 6H7.16602V7V17V18H8.16602H10.166H11.166V17V7V6H10.166H8.16602ZM0.166016 12H4.16602V18H0.166016V12Z"
            fill="#4D4E65" />
    </svg>
);

export default IconSignalLow;